import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import {
  getListDuNoNhanVay,
  updateDataSearch,
} from "../../../../../actions/DuNoNhanVay";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import userApi from "service/userApi";

export const SearchNangCao = (props) => {
  const DanhSachCombo = {
    nhanVienOption: [
      {
        label: "Test828@gmail.com",
        value: "Test828@gmail.com",
      },
      {
        label: "Test@gmail.com",
        value: "Test@gmail.com",
        selected: true,
      },
    ],
  };

  const [listUser, setListUser] = useState(DanhSachCombo.nhanVienOption);

  const initTrangThai = {
    TrangThaiCombo: [
      { value: "0", label: "Tất cả" },
      { value: "1", label: "Đang trả lãi" },
      { value: "3", label: "Nợ" },
      { value: "4", label: "Quá hạn" },
    ],
  };
  const [dataTrangThai, setdataTrangThai] = useState(
    initTrangThai.TrangThaiCombo
  );

  useEffect(() => {
    //Code lấy list user
    userApi.combo().then((response) => {
      const dataComboUser = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setListUser(dataComboUser);
    });
  }, []);

  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchDuNoNhanVay);

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const onSearch = () => {
    props.onHide(false);
    dispatch(getListDuNoNhanVay(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: event,
        })
      );
      dispatch(getListDuNoNhanVay(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  // convert sự kiện tìm kiếm từ ngày đến ngày
  var dateFrom = currentDate();
  if (dataSearch.dateFrom === "01/01/2001") dateFrom = "";
  else dateFrom = dataSearch.dateFrom;
  var dateTo = currentDate();
  if (dataSearch.dateTo === "01/01/4000") dateTo = "";
  else dateTo = dataSearch.dateTo;
  dateTo = convertDate(dateTo);
  dateFrom = convertDate(dateFrom);
  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-file-search"></i>
          </span>{" "}
          Tìm kiếm nâng cao
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="row repeater-default">
            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="email-addr">Tên, SĐT, Địa chỉ chủ nợ</label>
              <br />
              <input
                type="text"
                className="form-control input-sm"
                value={dataSearch.tenChuNo}
                onChange={updateTextValue("tenChuNo")}
                onKeyDown={handleKeyDown}
              />
            </div>

            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="bio" className="cursor-pointer">
                Số tiền vay
              </label>
              <br />
              <input
                type="text"
                className="form-control input-sm"
                value={dataSearch.sotienvay}
                onChange={updateTextValue("sotienvay")}
                onKeyDown={handleKeyDown}
              />
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="tel-input">Từ ngày</label>
              <br />
              <DateTimePicker
                value={dateFrom}
                onChange={onChangeDate("dateFrom")}
                name="dateFrom"
              ></DateTimePicker>
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="tel-input">Đến ngày</label>
              <br />
              <DateTimePicker
                value={dateTo}
                onChange={onChangeDate("dateTo")}
                name="dateFrom"
              ></DateTimePicker>
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="tel-input">Nhân viên</label>
              <br />
              <select
                name="nhanvien"
                className="selectBox form-control input-sm"
                value={dataSearch.nhanvien}
                onChange={updateDropdown("nhanvien")}
              >
                {listUser &&
                  listUser.map((item, idx) => (
                    <option key={"objComboStore1" + idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
              </select>
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="tel-input">Mã tài sản</label>
              <br />
              <input
                className="form-control input-sm"
                type="text"
                value={dataSearch.mataisan}
                onChange={updateTextValue("mataisan")}
                onKeyDown={handleKeyDown}
              />
            </div>

            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="profession">Trạng thái</label>

              <select
                name="kho"
                className="selectBox form-control input-sm"
                value={dataSearch.trangthai}
                onChange={updateDropdown("trangthai")}
              >
                {dataTrangThai &&
                  dataTrangThai.map((item, idx) => (
                    <option key={"objComboStore1" + idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <a
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={onSearch}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-magnify"></i>
          </span>
          Tìm kiếm
        </a>

        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
